import React from 'react';
import Lottie from 'react-lottie';
import * as animationData from 'assets/lottie/preloader.json';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData.default,
};

function Loader() {
    return (
        <div
            style={{
                width: 128,
                height: 128,
                position: 'absolute',
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
            }}
        >
            <Lottie
                isPaused={false}
                isStopped={false}
                options={defaultOptions}
                height={128}
                width={128}
            />
        </div>
    );
}

export default Loader;
